import { useContext, useRef, useEffect, useState } from 'react'
// import { useRouter } from 'next/router'

// Context
import { ModalContext } from '../../context/ModalContext'

const ModalFrame = () => {
  // States
  const [confirmed, setConfirmed] = useState(false)
  const [loaded, setLoaded] = useState(false)

  // const router = useRouter()
  const drawingAppUrl = process.env.NEXT_PUBLIC_DRAWING_APP_URL

  // Context
  const modalContext = useContext(ModalContext)

  // Refs
  const iframeRef = useRef()

  useEffect(() => {
    if (window) window.addEventListener('message', windowMessageHandler)
    return () => {
      if (window) window.removeEventListener('message', windowMessageHandler)
      setLoaded(false)
    }
  }, [])

  useEffect(() => {
    if (!modalContext.modalFrameActive && loaded) setLoaded(false)
  }, [modalContext.modalFrameActive])

  useEffect(() => {
    if (modalContext.modalHasFramePrompt) {
      iframeRef.current.contentWindow.postMessage({ showPrompt: true }, drawingAppUrl)
      modalContext.setModalHasFramePrompt(false)
    }
  }, [modalContext.modalHasFramePrompt])

  const sendMessage = () => {
    if (iframeRef.current && modalContext.modalFrameActive) {
      const drawingJson = modalContext.modalFrameInput
      const drawingType = modalContext.modalIsIndoor ? 'indoor' : 'outdoor'
      const sportType = process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT ?? 'football'
      iframeRef.current.contentWindow.postMessage(
        { drawing_JSON: drawingJson, drawingType: drawingType, sportType: sportType },
        drawingAppUrl
      )
    }
  }

  const loadHandler = () => {
    if (!loaded) setLoaded(true)
  }

  useEffect(() => {
    if (loaded && confirmed) setTimeout(() => sendMessage(), 1000)
  }, [confirmed])

  const closeHandler = () => {
    modalContext.setModalFrameInput(null)
    modalContext.setModalFrameActive(false)
    setLoaded(false)
    setConfirmed(false)
  }

  const saveHandler = (e) => {
    modalContext.setModalFrameOutput(e.data.data)
    closeHandler()
  }

  const windowMessageHandler = (e) => {
    if (e.origin !== drawingAppUrl || !e.data.type) return

    switch (e.data.type) {
      case 'confirm':
        setConfirmed(true)
        break
      case 'close':
        closeHandler()
        break
      case 'recieved':
        modalContext.setStateClass('is-loaded')
        break
      case 'save':
        saveHandler(e)
        break
    }
  }

  return (
    <div className="ModalFrame-container">
      {modalContext.modalFrameActive && (
        <iframe
          src={drawingAppUrl}
          className={`ModalFrame${confirmed ? ' is-active' : ''}`}
          onLoad={loadHandler()}
          width="100%"
          height="100%"
          ref={iframeRef}
        />
      )}
    </div>
  )
}

export default ModalFrame
